import { DirectLineActivity } from "botframework-webchat-core";

const generateUsername = (testUsername: boolean = false) => {
  let rdm = Math.random().toString(36).slice(-6);
  if (testUsername == true) {
    return `Tests_${rdm}`;
  } else {
    return `User_${rdm}`;
  }
};

const shuffleArray = (array: Array<any>) => {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

const allowSpeech = () => {
  document.dispatchEvent(new CustomEvent("allowChatbotSpeakAnimationsEvent"));
};

// Disable speech animations
const preventSpeech = () => {
  document.dispatchEvent(new CustomEvent("preventChatbotSpeakAnimationsEvent"));
};

const sendActivity = (activity: DirectLineActivity) => {
  const customActEvent = new CustomEvent("sendMessageEvent", {
    detail: {
      meta: {
        method: "speech",
      },
      ...activity,
    },
  });
  document.dispatchEvent(customActEvent);
};

const GetActivityCounter = (): number => {
  let stored = localStorage.getItem("activityCount");
  if (stored) return parseInt(stored);
  else return 0;
};

const UpdateActivityCounter = (operator: string): void => {
  let stored = localStorage.getItem("activityCount");
  if (operator == "reset") {
    localStorage.setItem("activityCount", "0");
  }
  if (!stored && operator == "+") {
    localStorage.setItem("activityCount", "1");
  } else if (!stored && operator == "-")
    localStorage.setItem("activityCount", "0");
  else if (stored) {
    let numberOfActivity = parseInt(stored);
    if (operator == "+") numberOfActivity++;
    else if (operator == "-") numberOfActivity--;
    localStorage.setItem("activityCount", numberOfActivity.toString());
  }
};

export {
  generateUsername,
  shuffleArray,
  allowSpeech,
  preventSpeech,
  sendActivity,
  GetActivityCounter,
  UpdateActivityCounter,
};
